/**
 * PWA 동적 매니페스트 생성
 * Firestore에서 가져온 홈페이지 설정값으로 manifest를 동적 생성하여
 * <link rel="manifest"> 태그에 주입합니다.
 *
 * Cloud Function 배포 없이도 매니페스트가 정상 동작하도록 보장합니다.
 */
export function setDynamicManifest(config: {
  title: string;
  description?: string;
  faviconURL?: string;
  bgColor?: string;
  themeColor?: string;
}) {
  if (typeof window === 'undefined') return;

  const headFavicon =
    document
      .querySelector<HTMLLinkElement>('link[rel="icon"]')
      ?.getAttribute('href') || '';
  const resolvedIcon = (config.faviconURL || headFavicon || '').trim();

  const manifest = {
    short_name: config.title || '홈페이지',
    name: config.title || '홈페이지',
    description: config.description || '',
    icons: [
      ...(resolvedIcon
        ? [
            { src: resolvedIcon, sizes: '192x192', type: 'image/png' },
            { src: resolvedIcon, sizes: '512x512', type: 'image/png' },
            {
              src: resolvedIcon,
              sizes: '512x512',
              type: 'image/png',
              purpose: 'maskable',
            },
          ]
        : []),
    ],
    start_url: '/',
    background_color: config.bgColor || '#ffffff',
    theme_color: config.themeColor || '#000000',
    display: 'standalone' as const,
    orientation: 'portrait' as const,
  };

  const blob = new Blob([JSON.stringify(manifest)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);

  // 기존 <link rel="manifest"> 태그를 찾아서 교체, 없으면 새로 생성
  let link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'manifest';
    document.head.appendChild(link);
  }

  // 이전 blob URL 해제 (메모리 누수 방지)
  if (link.href && link.href.startsWith('blob:')) {
    URL.revokeObjectURL(link.href);
  }

  link.href = url;
}
